/* Vyne Performance - header behavior (static asset) */
(function () {
  function vyneHeaderBoot(sectionId, cartUrl, sticky) {
    var rootId = 'shopify-section-' + sectionId;

    function init() {
      var root = document.getElementById(rootId);
      if (!root) { return; }
      if (root.dataset.vyneInit === 'true') { return; }
      root.dataset.vyneInit = 'true';

      var header = root.querySelector('[data-vyne-header]');
      var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      /* Track every listener bound OUTSIDE `root` (document/window) so teardown()
         can remove them all. Listeners bound on nodes inside `root` are dropped
         automatically when Shopify replaces root.innerHTML, so they don't leak
         and don't need tracking. */
      var globalListeners = [];
      function addGlobal(target, type, handler, opts) {
        target.addEventListener(type, handler, opts);
        globalListeners.push({ target: target, type: type, handler: handler, opts: opts });
      }
      root._vyneGlobalListeners = globalListeners;

      /* ---------- Sticky shadow on scroll ---------- */
      if (sticky) {
      if (header) {
        var onScroll = function () {
          if (window.scrollY > 4) {
            header.classList.add('vyne-header--scrolled');
          } else {
            header.classList.remove('vyne-header--scrolled');
          }
        };
        addGlobal(window, 'scroll', onScroll, { passive: true });
        onScroll();
      }
      }

      /* ---------- Reactive cart count ---------- */
      var cartCountEl = root.querySelector('[data-vyne-cart-count]');
      var cartSrEl = root.querySelector('[data-vyne-cart-sr]');

      function renderCartCount(count) {
        count = parseInt(count, 10);
        if (isNaN(count) || count < 0) { return; }
        if (cartCountEl) {
          cartCountEl.textContent = String(count);
          if (count === 0) {
            cartCountEl.setAttribute('hidden', '');
            cartCountEl.setAttribute('aria-hidden', 'true');
          } else {
            cartCountEl.removeAttribute('hidden');
            cartCountEl.setAttribute('aria-hidden', 'false');
          }
        }
        if (cartSrEl) {
          cartSrEl.textContent = count + ' ' + (count === 1 ? 'item' : 'items') + ' in cart';
        }
      }

      /* Authoritative fallback: pull a fresh count from /cart.js. Used when a
         cart event carries no count, or after an intercepted cart mutation. */
      var cartFetchPending = false;
      function refreshCartFromServer() {
        if (cartFetchPending || typeof window.fetch !== 'function') { return; }
        cartFetchPending = true;
        window.fetch(cartUrl + '.js', {
          headers: { 'Accept': 'application/json' },
          credentials: 'same-origin'
        })
          .then(function (res) { return res && res.ok ? res.json() : null; })
          .then(function (data) {
            if (data && typeof data.item_count !== 'undefined') {
              renderCartCount(data.item_count);
            }
          })
          .catch(function () { /* network error: keep existing count */ })
          .then(function () { cartFetchPending = false; });
      }

      /* Read a count straight out of a cart event payload when one is present,
         covering the common shapes from Dawn and popular AJAX-cart apps. */
      function countFromEvent(e) {
        var d = e && e.detail;
        if (!d) { return null; }
        if (typeof d.item_count === 'number') { return d.item_count; }
        if (d.cart && typeof d.cart.item_count === 'number') { return d.cart.item_count; }
        if (d.cartData && typeof d.cartData.item_count === 'number') { return d.cartData.item_count; }
        return null;
      }

      function onCartEvent(e) {
        var count = countFromEvent(e);
        if (count !== null) {
          renderCartCount(count);
        } else {
          refreshCartFromServer();
        }
      }

      var cartEventNames = ['cart:change', 'cart:updated', 'cart:refresh', 'cart:build', 'ajaxCart.afterCartLoad'];
      cartEventNames.forEach(function (name) {
        addGlobal(document, name, onCartEvent);
      });

      /* Fallback net: many themes/apps add to cart via fetch() to
         /cart/{add,change,update,clear} without firing a standard event. Wrap
         fetch once globally (idempotently) and refresh after any cart mutation. */
      if (typeof window.fetch === 'function' && !window.__vyneFetchPatched) {
        var origFetch = window.fetch;
        window.__vyneFetchPatched = true;
        window.fetch = function () {
          var args = arguments;
          var url = '';
          try {
            url = (typeof args[0] === 'string') ? args[0] : (args[0] && args[0].url) || '';
          } catch (err) { url = ''; }
          var promise = origFetch.apply(this, args);
          if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
            promise.then(function () {
              document.dispatchEvent(new CustomEvent('vyne:cart:mutated'));
            }).catch(function () {});
          }
          return promise;
        };
      }
      addGlobal(document, 'vyne:cart:mutated', function () { refreshCartFromServer(); });

      /* ---------- Desktop dropdowns ---------- */
      var dropdowns = root.querySelectorAll('[data-vyne-dropdown]');

      function closeAllDropdowns() {
        Array.prototype.forEach.call(dropdowns, function (dd) {
          var t = dd.querySelector('[data-vyne-dropdown-trigger]');
          var m = dd.querySelector('[data-vyne-dropdown-menu]');
          if (t) { t.setAttribute('aria-expanded', 'false'); }
          if (m) { m.removeAttribute('data-open'); }
        });
      }

      var isDesktop = function () { return window.matchMedia('(min-width: 990px)').matches; };

      Array.prototype.forEach.call(dropdowns, function (dd) {
        var trigger = dd.querySelector('[data-vyne-dropdown-trigger]');
        var menu = dd.querySelector('[data-vyne-dropdown-menu]');
        if (!trigger || !menu) { return; }

        /* data-open + aria-expanded are always set together via these helpers,
           and BOTH hover and click route through them, so the visual state and
           the reported aria-expanded can never desync. */
        var open = function () {
          closeAllDropdowns();
          trigger.setAttribute('aria-expanded', 'true');
          menu.setAttribute('data-open', 'true');
        };
        var close = function () {
          trigger.setAttribute('aria-expanded', 'false');
          menu.removeAttribute('data-open');
        };

        /* Pointer hover (desktop only) opens/closes through the same helpers. */
        dd.addEventListener('mouseenter', function () {
          if (isDesktop()) { open(); }
        });
        dd.addEventListener('mouseleave', function () {
          if (isDesktop()) { close(); }
        });

        trigger.addEventListener('click', function (e) {
          if (isDesktop()) {
            e.preventDefault();
            if (trigger.getAttribute('aria-expanded') === 'true') {
              close();
            } else {
              open();
            }
          }
        });

        /* Keyboard: ArrowDown / Enter opens and moves focus into the menu. */
        trigger.addEventListener('keydown', function (e) {
          if (!isDesktop()) { return; }
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            open();
            var firstLink = menu.querySelector('.vyne-header__dropdown-link');
            if (firstLink) { firstLink.focus(); }
          }
        });

        /* Arrow-key navigation between dropdown links. */
        menu.addEventListener('keydown', function (e) {
          if (!isDesktop()) { return; }
          var links = Array.prototype.slice.call(menu.querySelectorAll('.vyne-header__dropdown-link'));
          if (!links.length) { return; }
          var idx = links.indexOf(document.activeElement);
          if (e.key === 'ArrowDown') {
            e.preventDefault();
            links[(idx + 1) % links.length].focus();
          } else if (e.key === 'ArrowUp') {
            e.preventDefault();
            links[(idx - 1 + links.length) % links.length].focus();
          } else if (e.key === 'Home') {
            e.preventDefault();
            links[0].focus();
          } else if (e.key === 'End') {
            e.preventDefault();
            links[links.length - 1].focus();
          }
        });

        dd.addEventListener('keydown', function (e) {
          if (e.key === 'Escape') {
            close();
            trigger.focus();
          }
        });

        /* Close when focus leaves the item entirely (keyboard tab-out). */
        dd.addEventListener('focusout', function (e) {
          if (!dd.contains(e.relatedTarget)) {
            close();
          }
        });
      });

      /* Close any open dropdown on outside click. */
      addGlobal(document, 'click', function (e) {
        if (!root.contains(e.target)) {
          closeAllDropdowns();
        }
      });

      /* ---------- Search toggle ---------- */
      var searchToggle = root.querySelector('[data-vyne-search-toggle]');
      var searchPanel = root.querySelector('[data-vyne-search-panel]');
      var searchInput = root.querySelector('[data-vyne-search-input]');
      if (searchToggle && searchPanel) {
        var closeSearch = function () {
          searchPanel.removeAttribute('data-open');
          searchToggle.setAttribute('aria-expanded', 'false');
        };
        searchToggle.addEventListener('click', function () {
          if (searchPanel.getAttribute('data-open') === 'true') {
            closeSearch();
          } else {
            searchPanel.setAttribute('data-open', 'true');
            searchToggle.setAttribute('aria-expanded', 'true');
            if (searchInput) { searchInput.focus(); }
          }
        });
        addGlobal(document, 'keydown', function (e) {
          if (e.key === 'Escape' && searchPanel.getAttribute('data-open') === 'true') {
            closeSearch();
            searchToggle.focus();
          }
        });
      }

      /* ---------- Mobile drawer ---------- */
      var drawer = root.querySelector('[data-vyne-drawer]');
      var backdrop = root.querySelector('[data-vyne-backdrop]');
      var openBtn = root.querySelector('[data-vyne-drawer-open]');
      var closeBtn = root.querySelector('[data-vyne-drawer-close]');
      var lastFocused = null;
      var inertedNodes = [];
      var supportsInert = ('inert' in HTMLElement.prototype);

      function applyInert(node) {
        var hadAriaHidden = node.hasAttribute('aria-hidden');
        inertedNodes.push({
          node: node,
          hadAriaHidden: hadAriaHidden,
          prevAriaHidden: hadAriaHidden ? node.getAttribute('aria-hidden') : null
        });
        if (supportsInert) { node.inert = true; }
        node.setAttribute('aria-hidden', 'true');
      }

      /* Make everything outside the drawer + backdrop inert/aria-hidden so the
         screen-reader virtual cursor and browser find-in-page cannot reach the
         page behind the modal. The drawer/backdrop subtree stays reachable. */
      function setBackgroundInert(on) {
        if (!document.body) { return; }
        if (on) {
          inertedNodes = [];
          Array.prototype.forEach.call(document.body.children, function (node) {
            if (node === drawer || node === backdrop) { return; }
            if (node.tagName === 'SCRIPT' || node.tagName === 'STYLE' || node.tagName === 'TEMPLATE') { return; }
            if (node.contains(drawer) || node.contains(backdrop)) {
              /* Our own section wrapper holds the header next to the drawer:
                 inert its children individually, skipping the drawer/backdrop. */
              Array.prototype.forEach.call(node.children, function (child) {
                if (child === drawer || child === backdrop) { return; }
                if (child.contains(drawer) || child.contains(backdrop)) { return; }
                if (child.tagName === 'SCRIPT' || child.tagName === 'STYLE' || child.tagName === 'TEMPLATE') { return; }
                applyInert(child);
              });
              return;
            }
            applyInert(node);
          });
        } else {
          inertedNodes.forEach(function (entry) {
            if (supportsInert) { entry.node.inert = false; }
            if (entry.hadAriaHidden) {
              entry.node.setAttribute('aria-hidden', entry.prevAriaHidden);
            } else {
              entry.node.removeAttribute('aria-hidden');
            }
          });
          inertedNodes = [];
        }
      }

      var openDrawer = function () {
        if (!drawer || !backdrop) { return; }
        lastFocused = document.activeElement;
        backdrop.hidden = false;
        drawer.hidden = false;
        /* force reflow so the transition runs */
        void drawer.offsetWidth;
        backdrop.setAttribute('data-open', 'true');
        drawer.setAttribute('data-open', 'true');
        if (openBtn) { openBtn.setAttribute('aria-expanded', 'true'); }
        document.body.style.overflow = 'hidden';
        setBackgroundInert(true);
        if (closeBtn) { closeBtn.focus(); }
      };

      var closeDrawer = function () {
        if (!drawer || !backdrop) { return; }
        backdrop.removeAttribute('data-open');
        drawer.removeAttribute('data-open');
        if (openBtn) { openBtn.setAttribute('aria-expanded', 'false'); }
        document.body.style.overflow = '';
        setBackgroundInert(false);
        var finalize = function () {
          drawer.hidden = true;
          backdrop.hidden = true;
          drawer.removeEventListener('transitionend', finalize);
        };
        if (reduceMotion) {
          finalize();
        } else {
          drawer.addEventListener('transitionend', finalize);
          /* fallback in case transitionend doesn't fire */
          setTimeout(function () {
            if (drawer.getAttribute('data-open') !== 'true') { finalize(); }
          }, 400);
        }
        if (lastFocused && typeof lastFocused.focus === 'function') {
          lastFocused.focus();
        }
      };

      if (openBtn) { openBtn.addEventListener('click', openDrawer); }
      if (closeBtn) { closeBtn.addEventListener('click', closeDrawer); }
      if (backdrop) { backdrop.addEventListener('click', closeDrawer); }

      addGlobal(document, 'keydown', function (e) {
        if (e.key === 'Escape' && drawer && drawer.getAttribute('data-open') === 'true') {
          closeDrawer();
        }
      });

      /* Tab focus trap (belt-and-braces alongside background inert). */
      if (drawer) {
        drawer.addEventListener('keydown', function (e) {
          if (e.key !== 'Tab') { return; }
          if (drawer.getAttribute('data-open') !== 'true') { return; }
          var focusables = drawer.querySelectorAll('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])');
          if (!focusables.length) { return; }
          var first = focusables[0];
          var last = focusables[focusables.length - 1];
          if (e.shiftKey && document.activeElement === first) {
            e.preventDefault();
            last.focus();
          } else if (!e.shiftKey && document.activeElement === last) {
            e.preventDefault();
            first.focus();
          }
        });
      }

      /* ---------- Mobile accordion ---------- */
      var accordions = root.querySelectorAll('[data-vyne-accordion]');
      Array.prototype.forEach.call(accordions, function (btn) {
        btn.addEventListener('click', function () {
          var row = btn.closest('.vyne-header__drawer-item');
          if (!row) { return; }
          var panel = row.querySelector('[data-vyne-accordion-panel]');
          if (!panel) { return; }
          var isOpen = btn.getAttribute('aria-expanded') === 'true';
          btn.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
          if (isOpen) {
            panel.removeAttribute('data-open');
          } else {
            panel.setAttribute('data-open', 'true');
          }
        });
      });

      /* Cleanup hook so teardown() can undo background-inert even if the section
         is unloaded while the drawer is open. */
      root._vyneCleanup = function () {
        setBackgroundInert(false);
      };
    }

    function teardown() {
      var root = document.getElementById(rootId);
      if (root) {
        if (root._vyneGlobalListeners) {
          root._vyneGlobalListeners.forEach(function (l) {
            l.target.removeEventListener(l.type, l.handler, l.opts);
          });
          root._vyneGlobalListeners = null;
        }
        if (typeof root._vyneCleanup === 'function') {
          root._vyneCleanup();
          root._vyneCleanup = null;
        }
      }
      document.body.style.overflow = '';
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }

    document.addEventListener('shopify:section:load', function (e) {
      if (e.detail && e.detail.sectionId === sectionId) {
        init();
      }
    });
    document.addEventListener('shopify:section:unload', function (e) {
      if (e.detail && e.detail.sectionId === sectionId) {
        teardown();
      }
    });
  }
  var __q = window.__vyneHeaderQ || [];
  window.__vyneHeaderQ = { push: function (a) { vyneHeaderBoot.apply(null, a); } };
  for (var __i = 0; __i < __q.length; __i++) { vyneHeaderBoot.apply(null, __q[__i]); }
})();
